<div class="fix-ie-flex-min-height">
  <div class="root-wrapper">
    <ot-menu-bar
      (showMenuBar)="openMenu($event)"
      class="d-none d-md-block"
      [class.show-menu]="menuIsOpen"
    ></ot-menu-bar>
    <div class="main-page" [class.menu-open]="menuIsOpen">
      <ot-header (openMobileMenuBar)="isMobileMenuBarOpen = $event"></ot-header>
      <div class="project-pages">
        <router-outlet></router-outlet>
      </div>
      <div class="fix-ie-flex-footer"></div>
    </div>
  </div>
  <!-- <ot-footer></ot-footer> -->
</div>
<div class="app-update-banner" *ngIf="(updateAvailable$ | async) && !updateDismissed">
  <span>A new version of OfficeTroop is available.</span>
  <button type="button" class="app-update-banner--reload" (click)="reloadApp()">Reload</button>
  <button
    type="button"
    class="app-update-banner--dismiss"
    aria-label="Dismiss"
    (click)="updateDismissed = true"
  >
    &times;
  </button>
</div>
<div
  class="menu-bar--container d-none mobile-menu-bar"
  [class.d-block]="isMobileMenuBarOpen"
>
  <div class="menu-bar--wrapper">
    <ot-menu-bar-wrapper
      [isMobileMenu]="true"
      (closeMobileMenu)="isMobileMenuBarOpen = $event"
    ></ot-menu-bar-wrapper>
  </div>
</div>
